import axios from 'axios';

export const createAuthAxios = (config = {}) => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    withCredentials: true,
    timeout: 30000,
    ...config
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        localStorage.removeItem('some-key');
        window.location.href = '/signin';
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
